import React from 'react';
import { CheckCircleIcon, XCircleIcon, ClockIcon } from '@heroicons/react/24/outline';

const CompactStatusBadge = ({ isValid, backgroundValidating }) => {
  return (
    <div className="inline-flex items-center gap-2 rounded-full border bg-white px-3 py-1 text-xs shadow-sm">
      {backgroundValidating ? (
        <>
          <ClockIcon className="h-4 w-4 animate-spin text-blue-500" />
          <span className="text-gray-700">Revalidating…</span>
        </>
      ) : isValid ? (
        <>
          <CheckCircleIcon className="h-4 w-4 text-green-500" />
          <span className="text-green-700">Valid</span>
        </>
      ) : (
        <>
          <XCircleIcon className="h-4 w-4 text-red-500" />
          <span className="text-red-700">Issues</span>
        </>
      )}
    </div>
  );
};

export default CompactStatusBadge;



